/* Vuex actions for module App */
export default {};
